export default "__VITE_ASSET__2cd9bfd1__"